<template>
  <div class="study">
    <div class="study-container">
      <div class="top-banner">
        <van-search
          v-model="kw"
          shape="round" background="#4fc08d" 
          placeholder="请输入搜索关键词"
          @search="searchKW"
        />
        <van-tabs
          title-active-color="#ffffff" 
          title-inactive-color="#f0f0f0"
          v-model="activeTab"
          @change="tabChange"
        >
          <van-tab title="未开始" :name="1"></van-tab>
          <van-tab title="进行中" :name="2"></van-tab>
          <van-tab title="已结束" :name="3"></van-tab>
        </van-tabs>
      </div>
      <div class="content">
        <div class="event-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loadBusy" infinite-scroll-distance="30">

        <van-pull-refresh v-model="loadBusy" @refresh="onRefresh" style="min-height: 100%">
          <template v-if="eventList.length > 0">
            <div class="event-item" v-for="event in eventList" :key="event.id">
              <div class="item-header">
                <div class="item-category" v-if="event.category">{{ event.category.name }}</div>
                <div class="item-name">{{ event.name }}</div>
              </div>
              <div class="item-info">
                <div>{{event.start_at}} - {{event.end_at}}</div>
              </div>
              <div class="item-poster">
                <img :src="res_url + event.cover_img" />
              </div>
              <div class="action">
                <div class="btn" @click="showQr(event)" v-if="meta.state == 2">分享海报</div>
                <!-- <div class="btn" @click="showWXAQr(event)" v-if="event.share_wx_url && meta.state == 2">小程序海报</div> -->
                <div class="btn" @click="showStat(event)" >查看统计</div>
                <!-- <div class="btn" @click="showShareCard(event)" v-if="meta.state == 2">分享卡片</div> -->
                <div class="btn" @click="copyLink(event)" v-if="meta.state == 2">节目链接</div>
                <div class="btn" @click="copyWXALink(event)" v-if="event.share_wx_url && meta.state == 2">小程序链接</div>
              </div>
            </div>
          </template>
          <template v-else>
            <van-empty description="暂无更多内容" />
          </template>
        </van-pull-refresh>
        </div>
      </div>
    </div>
    <van-popup v-model="showQrcode" style="background: transparent">
      <div class="qrcode">
        <img :src="inviteQr" v-if="inviteQr" />
      </div>
    </van-popup>
    <Footer />
    <GMError />
    <div class="share_tips" v-if="show_tips" @click="show_tips = false">
      <div class="share_icon"></div>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import GMError from './component/GMError.vue';
import { mapState } from 'vuex'
import { Toast, Dialog } from 'vant'
import { eventList } from '@/api/event';
import QRCode from 'qrcode'

export default {
  name: 'GMLive',
  components: {
    Footer,
    GMError
  },
  data() {
    return {
      showQrcode: false,
      inviteQr: '',
      show_tips: false,

      loadBusy: false,
      page: 1,
      activeTab: 1,
      total_page: 0,
      eventList: [],
      kw: '',
      meta: {
        keyword: '',
        page: 1,
        state: 1,
      },
      showEdit: false,
      editId: undefined,
      editForm: {
        headimgurl: '',
        nickname: '',
        mobile: '',
      },
      share: {
        name: '凯蒙名医直通车',
        desc: '凯蒙名医直通车',
        imgUrl: '',
        link: '',
        success: function () {
          console.log('success')
        },
        cancel: function () {
          console.log('cancel')
        }
      },
    }
  },
  watch: {
    'showQrcode': function () {
      if (!this.showQrcode) {
        this.inviteQr = '';
      }
    }
  },
  computed: {
    ...mapState(['user']),
    res_url() {
      return window.__config__.res_url;
    },
    statusTypeMap() {
      return {
        0: 'default',
        1: 'warning',
        2: 'success',
        3: 'warning',
        9: 'danger'
      }
    },
    statusMap() {
      return {
        0: '未开始',
        1: '进行中',
        2: '已结束',
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    initShare: function () {
      // return;
      wx.ready(() => {
        let share = {
          ...this.share,
          success: function () {
            console.log('success', share)
          }
        }
        // wx.onMenuShareTimeline(share);
        // wx.onMenuShareAppMessage(share);
        // if ('updateTimelineShareData' in wx) {
        //   wx.updateTimelineShareData(share)
        // }
        // if ('updateAppMessageShareData' in wx) {
        //   wx.updateAppMessageShareData(share);
        // }
        wx.hideAllNonBaseMenuItem();
        // wx.showMenuItems({
        //   menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
        // });

      })
    },
    async copyLink(event) {
      try {
        if (navigator.clipboard) {
          let text = event.name + ' ' + event.share_link;
          await navigator.clipboard.writeText(text);
          Toast('复制成功');
        }
      } catch (e) {}
    },
    async copyWXALink(event) {
      try {
        if (navigator.clipboard) {
          let text = event.name + ' ' + event.share_wx_url;
          await navigator.clipboard.writeText(text);
          Toast('复制成功');
        }
      } catch (e) {}
    },
    async showShareCard(event) {
      let share = {
        ...this.share
      }
      if ('share' in event) {
        share = event.share;
        if (!share.title) {
          share.title = event.name;
        }
        if (!share.desc) {
          share.desc = event.name;
        }
      }
      if ('poster_img' in event && event.poster_img) {
        share.imgUrl = window.__config__.res_url + event.poster_img + '/share.jpg';
      }
      if ('share_link' in event) {
        share.link = event.share_link;
      }
      this.share = share;
      // console.log(this.share);
      await this.initShare();
      this.show_tips = true;
    },
    init() {
      this.loadData()
    },
    searchKW() {
      // console.log('search', this.kw)
      this.loadData({
        page: 1,
        state: this.activeTab,
        keyword: this.kw
      })
    },
    tabChange(evt) {
      // console.log('tabChange', evt)
      this.loadData({
        page: 1,
        state: evt,
        keyword: this.kw
      })
    },
    onRefresh() {
      this.loadData({
        page: 1,
        state: this.meta.state,
        keyword: this.meta.keyword
      })
    },
    loadData({ page = 1, state = 1, keyword = '' } = {}) {
      this.loadBusy = true;
      eventList({
        page,
        state,
        keyword
      }).then((resp) => {
        let { current, data, total } = resp.data
        this.page = current
        this.total_page = total
        
        this.eventList = current == 1 ? data : this.eventList.concat(data)
        // console.log('list', this.list)
        this.loadBusy = false
        this.meta = {
          page,
          state,
          keyword
        }
      })
    },
    loadMore() {
      if (this.meta.page -1 < this.total_page) {
        this.loadData({
          page: this.meta.page + 1,
          state: this.meta.state,
          keyword: this.meta.keyword
        })
      }
    },


    async initQr(event, link_url) {
      let shareBg = await (new Promise((resolve, reject) => {
        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.onload = () => {
          resolve(img)
        }
        img.src = this.res_url + event.share_img
      }))

      let canvas = document.createElement('canvas')
      canvas.width = 838
      canvas.height = 1490
      var ctx = canvas.getContext('2d')
      ctx.drawImage(shareBg, 0, 0);
      let qrcode = await QRCode.toCanvas(link_url, {
        margin: 0,
      })
      ctx.drawImage(qrcode, 255, 955, 330, 330)

      this.inviteQr = canvas.toDataURL('image/jpeg')
    },
    async showQr(event) {
      await this.initQr(event, event.share_link);
      this.showQrcode = true;
    },
    async showWXAQr(event) {
      await this.initQr(event, event.share_wx_url);
      this.showQrcode = true;
    },
    showStat(event) {
      this.$router.push('/GMEventStat/' + event.id)
    },
  }
}
</script>
<style lang="scss" scoped>
.study-container {
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  .top-banner {
    flex: 0 0 98px;
    background: #4fc08d;
  }
  .content {
    flex: 1 1 auto;
    width: 100%;
    overflow: hidden;
    background: #e3e3e3;

  .event-list {
      width: 100%;
      height: 100%;
      // background: red;
      overflow-y: scroll;
      padding: 10px;

      .event-item {
        padding: 10px;
        background: #fff;
        width: 100%;
        border-radius: 10px;
        margin-bottom: 12px;

        .item-header {
          padding: 5px 0 10px 0;
          border-bottom: 1px solid #999;

          .item-category {
            display: inline-block;
            color: #fff;
            padding: 3px 10px;
            font-size: 13px;
            background: #5c9b73;
            border-radius: 3px;
          }

          .item-name {
            margin-top: 5px;
            font-size: 16px;
            font-weight: 400;
          }
        }

        .item-poster {
          width: 100%;

          img {
            width: 100%;
          }
        }

        .item-info {
          margin: 8px 0;
          color: #999;
          line-height: 1.8em;
        }
        .action {
          margin-top: 10px;
          display: flex;
          .btn {
            width: 98px;
            margin-right: 10px;
            line-height: 28px;
            font-size: 16px;
            border: 1px solid #ccc;
            text-align: center;
            border-left: none;
        
            &:first-child {
              border-left: 1px solid #ccc;
            }
        
            &.rpget {
              background: #ccc;
            }
        
            &.rpnone {
              background: #ad0000;
              color: #fff;
            }
          }
        }
      }
    }

  }
}
.video_container {
  width: 90vw;
  height: 52vw;
  video {
    width: 100%;
  }
}
.qrcode {
  width: 68vw;
  border-radius: 20px;
  overflow: hidden;
  padding: 0;
  margin: 0;

  img {
    width: 100%;
    padding: 0;
    margin: 0;
  }
}
.headicon {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}
.share_tips {
  position: fixed;
  top: 0; left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}
.share_tips .share_icon {
  position: absolute;
  top: 5vw;
  right: 5vw;
  background: url(../../assets/share_icon.png) top left no-repeat;
  background-size: 100% auto;
  width: 68vw;
  height: 45vw;
}
</style>
